import "./../languageSelectorStyle.css"
import { useContext } from "react";
import { SelectedLanguageContext } from "../../../../../contexts/siteContentsContext";

export default function LanguageSelectorButton() {
  const { selectedLanguage } = useContext(SelectedLanguageContext);
    
    return(
      <div className="language-selector__selector-button">
        <img 
            className="language-selector__button" 
            src={selectedLanguage?.srcIcon} 
            alt={selectedLanguage?.alt}/>
      </div>
    );
}